/**
 * Created by Ning Jiang on 4/1/2016.
 */

import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { SoundConfig } from "../../SoundConfig";
import { INolimitAudioPlayer } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";

export class SoundManager {

        private static get soundPlayer(): INolimitAudioPlayer {
            return <INolimitAudioPlayer>SlotGame.sound;
        }

        private static currentAmbientLoopName:string = ""
     
        public static playAmbientLoop(name:string):void {
            this.stopAmbientLoop(this.currentAmbientLoopName);
            this.currentAmbientLoopName = name;
            this.soundPlayer.playTrack({name:name});
        }
    
        public static stopAmbientLoop(name:string):void {
            this.soundPlayer.stopTrack(name);
        }
    
        // Please NOTE the duration is in millisecond!
        public static fadeAmbienceLoop(volume:number, duration:number):void {
            volume = volume == 0 ? 0.001 : volume;
            this.soundPlayer.fadeTrack({name:this.currentAmbientLoopName, duration:duration,to:volume});
        }
    
        public static playSoundEffect(name:string, repeat?:number):void {
            this.soundPlayer.playTrack({ name: name, repeat: repeat });
        }
    
        public static stopSoundEffect(name:string):void {
            this.soundPlayer.stopTrack(name);
        }
    
        public static onFadeSoundEffect(name:string, volume:number, duration:number):void {
            SlotGame.sound.fadeEffect(name, volume, duration);
        }
    
        public static reset():void{
            SoundManager.playAmbientLoop(SoundConfig.instance.INTENSITY_0_GAME_AMBIANCE);
        }
    
        public static bonusMusicBigWin(active:boolean):void{
            if(active)
                SoundManager.fadeAmbienceLoop(1,1);
            else
                SoundManager.fadeAmbienceLoop(0,1);
        }
    
        public static playRespin():void{
            SoundManager.playAmbientLoop(SoundConfig.instance.RESPIN_MUSIC);
        }
    
        public static playBonus():void{
            SoundManager.playAmbientLoop(SoundConfig.instance.FS_GAME_AMBIANCE);
        }
    }